import React from "react";
import { RawStaticInput } from "./StaticInput";
export var StaticFormGroup = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement("div", { className: "form-group" },
        React.createElement(RawStaticInput, { value: value, label: label })));
};
